<template>
  <div class="maskCon pf">
    <div class="inMaskCon pa center">
      <div class="head f14 pr">
        <b></b>{{ title }}
        <i class="f26 pa topCenter closeIcon cp"  @click="closeFn">×</i>
      </div>
      <div class="bodyCon scrollStyle minScrollStyle">
        <slot></slot>
      </div>
      <div class="footCon clearfix">
        <Button class="fr" type="info" :loading="loading" @click="confirm" v-if="confirmText!=''">{{ confirmText }}</Button>
        <Button class="fr" @click="closeFn">取消</Button>
        <!-- <span class="fr errorCol f14" v-if="modelType ==1">注：注入的dll文件必须是64位，否则可能会造成客户端崩溃！！！</span> -->
      </div>
    </div>
  </div>
</template>
<script>
import DefaultModal from '_c/modals/defaultModal'
export default {
  props: ['title', 'confirmText', 'loading', 'modelType'],
  data() {
    return {
    }
  },
  components: {
    DefaultModal,
  },
  methods: {
    confirm() {
      this.$emit('confirmFn')
    },
    closeFn() {
      this.$emit('closeFn')
    }
  }
}
</script>
<style lang="scss" scoped>
.maskCon{
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: .6);
  top: 0;
  left: 0;
  z-index: 99;
  .inMaskCon{
    width: 700px;
    background: #fff;
    .head{
      line-height: 40px;
      text-indent: 20px;
      border-bottom: 1px solid #eee;
      b{
        width: 2px;
        height: 16px;
        display: inline-block;
        background: #0099cc;
        vertical-align: middle;
        margin-right: 10px;
      }
      .closeIcon{
          right: 20px;
        }
    }
    .bodyCon{
      max-height: 660px;
      padding: 16px;
      overflow: hidden;
      overflow-y: auto;
      box-sizing: border-box;
    }
    .footCon{
      border-top: 1px solid #eee;
      padding: 10px 0;
      .fr{
        margin: 0  20px 0 0;
      }
    }
  }
}
</style>